import React from "react";
import {InputGroup} from "react-bootstrap";

function STCInputGroupText(props){

    return(
        <InputGroup.Text
            style={props.style}
            className={props.className}

            size={props.size}
        >
            {props.children}
        </InputGroup.Text>
    )
}
export default STCInputGroupText;